import PortalIdParser from 'PortalIdParser';
import { DataFetchingClientProvider, DataFetchingClient } from 'data-fetching-client';
import { Provider } from 'react-redux';
import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import { configureStore } from './utils/configureStore';
import { ViewApplication } from './containers/ViewApplication';
import { jsx as _jsx } from "react/jsx-runtime";
export const getLocaleInfo = () => {
  const browserLanguage = getBrowserLanguage();
  return {
    locale: browserLanguage,
    langEnabled: true
  };
};
export const prepareApp = () => {
  PortalIdParser.get();
  const store = configureStore({});
  const dfcClient = new DataFetchingClient();
  return {
    props: {
      store,
      dfcClient
    }
  };
};
export function AppComponent({
  store,
  dfcClient
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dfcClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(ViewApplication, {})
    })
  });
}